import { CallbackTemplate } from './template'
import { useOAuthCallback } from './use-oauth-callback'

export const Callback = (): JSX.Element => {
  const { status } = useOAuthCallback()
  return <CallbackTemplate status={status} />
}
